import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  loginWithGoogle,
  logout,
  onAuthStateChange,
  isAdminUser,
  signInAnonymouslyForPublicForm,
} from '../services/firebase';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChange((user) => {
      setUser(user);
      setIsAdmin(isAdminUser(user));
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const login = async () => {
    try {
      const user = await loginWithGoogle();
      setUser(user);
      setIsAdmin(isAdminUser(user));
      return user;
    } catch (error) {
      console.error('Error logging in:', error);
      throw error;
    }
  };

  const logoutUser = async () => {
    try {
      await logout();
      setUser(null);
      setIsAdmin(false);
    } catch (error) {
      console.error('Error logging out:', error);
      throw error;
    }
  };

  const anonymousLogin = async () => {
    try {
      const user = await signInAnonymouslyForPublicForm();
      setUser(user);
      return user;
    } catch (error) {
      console.error('Error signing in anonymously:', error);
      throw error;
    }
  };

  const value = {
    user,
    loading,
    isAdmin,
    login,
    logout: logoutUser,
    anonymousLogin,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
